/*
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { h, Host } from "@stencil/core";
export class DiscoverySpinner {
    constructor() {
        this.message = 'Loading...';
    }
    componentDidLoad() {
        this.message = this.el.innerText || this.message;
    }
    render() {
        return (h(Host, { key: '279e166844255eca1e4f4c20e30460d2ae805865' }, h("div", { key: '16bb4e6bc05dbd93eb4ec2836bb93817110011ee', class: "loader" }), h("span", { key: 'c9de961b88c7a060b78f2cb7947f07a6e5cf569a', class: "message" }, this.message), h("span", { key: '21489d7d7c22df46a3e869f4b2485f735cddef59', class: "hidden" }, h("slot", { key: '61f1afa380a64c6988990d859bcd4763720f751b' }))));
    }
    static get is() { return "discovery-spinner"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["discovery-spinner.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["discovery-spinner.css"]
        };
    }
    static get properties() {
        return {
            "message": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "message",
                "reflect": false,
                "defaultValue": "'Loading...'"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=discovery-spinner.js.map
